
import { JSEncrypt } from 'jsencrypt'
// 加密
export function encryptedData(data) {
    // 私钥 和后端沟通写死了
    var publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCitqHxE0z31rPjDY44pk33/tD9CljtbeirK5UgMBiW+3xBo/JfrwGOYiczk+ZoteAAWMVH+jmc1v93SZT7kcPbtiA1G1Pg6m2c1fSIQQ3D9BmbjP48ts6tXlDcpvpnsUP2WSXAnB2F5KP5NEoVqJHPrmkM9UTezIk/d7/FkG2RowIDAQAB'
    // 新建JSEncrypt对象
    const encryptor = new JSEncrypt()
    // 设置公钥
    encryptor.setPublicKey(publicKey)
    // 加密数据
    return encryptor.encrypt(data)
}
